import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input"];

  submit(event) {
    event.preventDefault();
    const query = this.inputTarget.value.trim();
    const path = `/admin/membership_search${query ? `?search=${encodeURIComponent(query)}` : ""}`;
    window.location.href = path;
  }
}
